import "./CardSelectDoctor.scss";
import { useRef } from "react";
import * as CheckboxRadix from "@radix-ui/react-checkbox";
import { useClickOutside } from "@/hooks/useClickOutside.ts";
import { Col } from "../Col";
import { CheckIcon } from "@/icons";
import { HeadingLevel } from "@/types/headings";

type CardSelectDoctorProps = {
  id: string;
  title: string;
  titleTag?: HeadingLevel;
  href?: string;
  description?: string;
  isExternal?: boolean;
  showIcon?: boolean;
  asLink?: "a";
  className?: string;
  setSelectedCard?: (id?: string) => void;
  description2?: string;
  isActive: boolean;
  keepSelectionOnNavigation?: boolean;
  disabled?: boolean;
};

export const CardSelectDoctor = ({
  id,
  title,
  titleTag: TitleTag = "h1",
  description,
  className,
  setSelectedCard = () => {},
  description2,
  keepSelectionOnNavigation = false,
  disabled = false,
  isActive = false,
}: CardSelectDoctorProps) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  useClickOutside(
    dropdownRef,
    isActive,
    () => setSelectedCard(undefined),
    () => setSelectedCard(undefined),
    keepSelectionOnNavigation,
  );

  // Generate class names based on active and disabled states
  const cardClasses = `${className} ${
    isActive ? "ui-is-active" : "ui-card-search"
  } shadow br-x4 px-x24 py-x16 base-row bg-white gap-x16 ${
    disabled ? "ui-card-disabled" : "cursor-pointer"
  }`;

  // Handle click only if not disabled
  const handleClick = () => {
    if (!disabled) {
      setSelectedCard(id);
    }
  };

  return (
    <div
      ref={dropdownRef}
      className={cardClasses}
      onClick={handleClick}
      aria-disabled={disabled}
    >
      <CheckboxRadix.Root
        id={id}
        checked={isActive}
        disabled={disabled}
        className={"ui-checkbox-filter"}
        title={`Seleziona ${title}`}
        aria-label={`Seleziona ${title}`}
      >
        <CheckboxRadix.Indicator>
          <CheckIcon width={14} height={14} color="white" />
        </CheckboxRadix.Indicator>
      </CheckboxRadix.Root>
      <Col>
        <TitleTag className="flex-1 pb-x8 fs-5 md-fs-4 text-slate-20 fw-semibold">
          {title}
        </TitleTag>
        <p className="fs-7 md-fs-custom fw-regular text-slate-28">
          {description}
        </p>
        {description2 && (
          <p className="fs-7 md-fs-custom fw-regular text-slate-28 pt-x16">
            {description2}
          </p>
        )}
      </Col>
    </div>
  );
};
